<script>
export default {
    props: [
        'defaultOption',
        'selectName',
        'options'
    ],
    data() {
        return {
            _elemName: '',
            _eventName: '',
            selected: this.defaultOption
        };
    },
    computed: {
        elemName() {
            if (!this._elemName) {
                this._elemName = this.selectName.split(/(?=[A-Z])/).join('-').toLowerCase();
            }
            return this._elemName;
        },
        eventName() {
            if (!this._eventName) {
                this._eventName = `select-${this.elemName}`;
            }
            return this._eventName;
        }
    },
    mounted() {
        this.$eventsBus.$on(`${this.eventName}-change`, this.handleChangeCapture);
    },
    beforeDestroy() {
        this.$eventsBus.$off(`${this.eventName}-change`, this.handleChangeCapture);
    },
    watch: {
        selected(is, was) {
            if (!is) {
                this.selected = this.defaultOption;
            } else {
                this.emitSelected(is, was);
            }
        }
    },
    methods: {
        handleChangeCapture(is) {
            this.selected = is;
        },
        emitSelected(is, was) {
            this.$eventsBus.$emit(this.eventName, {is: is, was: was});
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/atoms/native-select.vue